
import { initPerformanceTables } from "./../js/performanceTables/initPerformanceTables.jsx";

initPerformanceTables("performance-table");
